import { UploadInputBaseProps } from '@/common/components/AntdForm/AntdFormEmployeeDocumentUpload.tsx'
import constate from 'constate'

type DocumentBucketContextType = {
  documentBucket: UploadInputBaseProps['documentBucket'] | 'workable'
}

export const [DocumentStorageConfigProvider, useDocumentStorageConfig] = constate(({ documentBucket }: DocumentBucketContextType) => {
  return {
    documentBucket,
  }
})